'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as AppLayout from '#pplx/frontend/apps/ask/layout/page/AppLayoutV2.js';
import { useChromeVisibility } from '#pplx/frontend/apps/ask/layout/primitives/ChromeVisibilityProviderShared.js';
import { SearchSidebar } from '#pplx/frontend/apps/ask/layout/sidebar/core/SearchSidebar.js';
import { useSidebarWidth } from '#pplx/frontend/apps/ask/layout/sidebar/host/useSidebarWidth.js';
import { SplitPane } from '#pplx/frontend/apps/ask/split-pane/SplitPane.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { SIDEBAR_DEFAULT_WIDTH } from '#pplx/frontend/sidebar-sdk/sidebarResizeConstants.js';
import { animated } from '@react-spring/web';
const AppBanner = Dynamic(async () => {
    // ast-grep-ignore: no-undestruct-await-import
    const AppBanner = await import('#pplx/frontend/apps/ask/layout/shell/banner/AppBanner.js');
    return AppBanner;
});
export function SearchLayout({ children }) {
    const { visible, spring } = useChromeVisibility();
    const { width: desktopSidebarWidth } = useSidebarWidth('sidebarWidth');
    const { isMobileStyle } = useIsMobile({ evaluateOnInit: true });
    const layoutStyle = {
        '--sidebar-pinned-width': `${isMobileStyle ? SIDEBAR_DEFAULT_WIDTH : desktopSidebarWidth}px`,
    };
    return (_jsx(AppLayout.Wrapper, { children: _jsx("div", { className: "contents", style: layoutStyle, children: _jsxs(SplitPane.Primary, { children: [visible && (_jsx(animated.div, { className: "flex h-full shrink-0", style: {
                            opacity: spring,
                            transform: spring.to((progress) => `translate3d(${(progress - 1) * 100}%, 0, 0)`),
                        }, children: _jsx(AppLayout.Sidebar, { children: _jsx(SearchSidebar, {}) }) })), _jsx(AppLayout.ContentWrapper, { banner: visible && !import.meta.env.VITE_IS_SIDECAR_BUILD ? _jsx(AppBanner, {}) : null, children: children })] }) }) }));
}
//# sourceMappingURL=SearchLayout.js.map